import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.5 5.812a3.278 3.278 0 0 0-.778-1.44 2.97 2.97 0 0 0-1.344-.833C19.505 3 12 3 12 3s-7.505 0-9.378.536a2.964 2.964 0 0 0-1.345.832c-.372.4-.64.896-.776 1.44C0 7.816 0 12 0 12s0 4.185.5 6.188c.277 1.107 1.091 1.978 2.122 2.273C4.495 21 12 21 12 21s7.505 0 9.378-.539c1.034-.295 1.845-1.166 2.121-2.273C24 16.185 24 12 24 12s0-4.185-.5-6.188ZM9.615 15.84V8.159l6.214 3.812-6.214 3.87Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "youtube"}) } }